import { useState, Children, cloneElement, isValidElement } from 'react';

export function Tabs({ children, defaultValue, value, onValueChange }) {
    const [internalValue, setInternalValue] = useState(defaultValue);
    const activeValue = value !== undefined ? value : internalValue;
    const setActive = (v) => {
        if (onValueChange) onValueChange(v)
        else setInternalValue(v)
    }

    return (
        <div class="tabs-container">
            {Children.map(children, child => isValidElement(child) ? cloneElement(child, { activeValue: activeValue, setActive }) : child)}
        </div>
    );
}
export function TabsList({ children, activeValue, setActive }) {
    return (
        <div class="tabs-head">
            {Children.map(children, child => isValidElement(child) ? cloneElement(child, { activeValue, setActive }) : child)}
        </div>
    );
}
export function TabsTrigger({ value, children, activeValue, setActive, disabled }) {
    const active = activeValue === value;
    return (
        <button disabled={disabled} class={`btn btn-gray${active?' active':''}${disabled?' disabled':''}`} onClick={() => !disabled && setActive(value)}>
            {children}
        </button>
    );
}
export function TabsContent({ value, children, activeValue }) {
    return activeValue === value ? <div class="tabs-body">{children}</div> : null;
}
